export const getSkeletonKeyForUrl = function (
  url: string,
  routeToSkeletonMap: { [key: string]: string }
): string | null {
  const pathname = new URL(url).pathname;
  return (
    Object.entries(routeToSkeletonMap).find(([pattern, skeletonKey]) => {
      if (pathname.indexOf(pattern) > -1) {
        return skeletonKey;
      }
    })?.[1] || null
  );
};

export const injectSkeletonForUrl = function (
  appName: string,
  url: string,
  isMobile: boolean,
  routeToSkeletonMap: { [key: string]: string },
  skeletons: Record<string, { desktop: string; mobile?: string }>
) {
  const skeletonKey = getSkeletonKeyForUrl(url, routeToSkeletonMap);
  if (!skeletonKey || !skeletons[skeletonKey]) {
    return;
  }

  const element = document.getElementById(`single-spa-application:${appName}`);
  if (!element) {
    return;
  }

  const skeletonConfig = skeletons[skeletonKey];
  element.innerHTML =
    isMobile && skeletonConfig.mobile
      ? skeletonConfig.mobile
      : skeletonConfig.desktop;
};

export const excludeSkeletons = function (
  routeToSkeletonMap: { [key: string]: string },
  skeletons: Record<string, { desktop: string; mobile?: string }>
): Record<string, { desktop: string; mobile?: string }> {
  const excludedKeys = new Set(Object.values(routeToSkeletonMap));

  return Object.fromEntries(
    Object.entries(skeletons).filter(([key]) => !excludedKeys.has(key))
  );
};
